export default {

    // 清除：所有数据
    initClearData(state, value) {
        state.account = value;
        state.regionValue = [];
        state.regionName = [];
    },
    // 存入：当前账户
    initAccount(state, value){
        state.account = value;
    },

    // 存入：选中的区域value
    initRegionValue(state, value){
        state.regionValue = value;
    },

    // 存入：选中的区域value
    initRegionName(state, value){
        state.regionName = value;
    },

    // 存入：当前打印表单数据
    initPrintFormData(state, value){
        state.printFormData = value;
    },

    initDeviceUuid(state, value){
        state.deviceUuid = value;
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js